import { BaseApiService } from '@services/baseApiService';
import { SectorOutputDTO } from '@types';
import { ApiResponse, ApiError } from '@/types/api';

class SectorService extends BaseApiService<SectorOutputDTO> {
  constructor() {
    super('sectors');
  }

  async create(data: Partial<SectorOutputDTO>): Promise<ApiResponse<SectorOutputDTO> | ApiError> {
    // Remove sensitive data if needed
    const roleData = {
      ...data,
    };
    
    return await super.create(roleData);
  }

  async update(id: string, data: Partial<SectorOutputDTO>): Promise<ApiResponse<SectorOutputDTO> | ApiError> {
    // Remove sensitive data if needed
    const roleData = {
      ...data,
    };
    
    return await super.update(id, roleData);
  }

  // You can add role-specific methods here if needed
}

export const sectorService = new SectorService(); 